// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.single_video {
  position: relative;
}
.single_video .single_video_section {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  background-color: #333333;
}
.single_video .single_video_section .description p {
  color: #ffffff;
}
.single_video .single_video_section .description p body p {
  color: #333333;
}
.single_video .single_video_section.lock-content {
  position: relative;
}
.single_video .single_video_section.lock-content .video-mask {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: transparent;
}
.single_video .single_video_section.lock-content .video-mask .mask-content {
  padding: 1.5rem;
  max-width: 250px;
  width: 100%;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  background: rgba(24, 24, 24, 0.8549019608);
  z-index: 1;
}
.single_video .single_video_section.lock-content .content-block {
  position: relative;
}
.single_video .single_video_section.lock-content .content-block i.fa-lock {
  font-size: 3rem;
  color: #909090;
  position: absolute;
  top: 45%;
  left: 50%;
  z-index: 1;
}
.single_video .single_video_section.lock-content .content-block .content {
  overflow: hidden;
  position: relative;
  filter: blur(2px);
}
.single_video .single_video_section.lock-content .content-block .content:before {
  content: "";
  height: 100%;
  width: 100%;
  background: #333333;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0.8;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/learn_practice/videos/singlevideo/_singlevideo.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AAEI;EACI,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,6BAAA;EACA,yBAAA;AAAR;AAEQ;EACI,cAAA;AAAZ;AACY;EACI,cAAA;AAChB;AAGQ;EACI,kBAAA;AADZ;AAGY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,uBAAA;AADhB;AAGgB;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,0CAAA;EACA,UAAA;AADpB;AAKY;EACI,kBAAA;AAHhB;AAQgB;EACI,eAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AANpB;AASgB;EACI,gBAAA;EACA,kBAAA;EACA,iBAAA;AAPpB;AASoB;EACI,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;AAPxB","sourcesContent":[".single_video {\n    position: relative;\n\n\n    .single_video_section {\n        position: relative;\n        display: flex;\n        align-items: flex-start;\n        justify-content: space-around;\n        background-color: #333333;\n\n        .description p {\n            color: #ffffff;\n            body p {\n                color: #333333 \n            }\n        }\n\n        &.lock-content {\n            position: relative;\n\n            .video-mask {\n                width: 100%;\n                height: 100%;\n                position: absolute;\n                left: 0;\n                top: 0;\n                background: transparent;\n\n                .mask-content {\n                    padding: 1.5rem;\n                    max-width: 250px;\n                    width: 100%;\n                    height: 100%;\n                    position: absolute;\n                    right: 0;\n                    top: 0;\n                    background: #181818da;\n                    z-index: 1;\n                }\n            }\n\n            .content-block {\n                position: relative;\n                // display: flex;\n                // align-content: center;\n                // justify-content: center;\n\n                i.fa-lock {\n                    font-size: 3rem;\n                    color: #909090;\n                    position: absolute;\n                    top: 45%;\n                    left: 50%;\n                    z-index: 1;\n                }\n\n                .content {\n                    overflow: hidden;\n                    position: relative;\n                    filter: blur(2px);\n\n                    &:before {\n                        content: '';\n                        height: 100%;\n                        width: 100%;\n                        background: #333333;\n                        position: absolute;\n                        left: 0;\n                        top: 0;\n                        opacity: 0.8;\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
